import React from 'react';
import { ProviderDocument, ProviderDocumentType } from '@uplift/api';
import { DocumentLayout } from './components';
import { CollaborativeAgreementUnsignedPreview } from './CollaborativeAgreementUnsignedPreview';
import { CollaborativeAgreementSignedPreview } from './CollaborativeAgreementSignedPreview';
import { CollaborativeAgreementCounterSignatureRequiredPreview } from './CollaborativeAgreementCounterSignatureRequiredPreview';
import { CollaborativeAgreementCounterSignedPreview } from './CollaborativeAgreementCounterSignedPreview';
import { CollaborativeAgreementExpiredPreview } from './CollaborativeAgreementExpiredPreview';
import { CollaborativeAgreementExpiringPreview } from './CollaborativeAgreementExpiringPreview';
import { StateExhibitSignedPreview } from './StateExhibitSignedPreview';
import { UploadedProviderDocumentPreview } from './UploadedProviderDocumentPreview';


export const DocumentPreview: React.FC<{
  document: ProviderDocument;
  setSelectedDocumentId: (documentId: string | null) => void;
}> = ({ document, setSelectedDocumentId }) => {
  switch (document.type) {
    case ProviderDocumentType.collaborativeAgreementUnsigned:
      return (
        <CollaborativeAgreementUnsignedPreview
          document={document.document}
          onSign={agreementId => setSelectedDocumentId(agreementId)}
        />
      );
    case ProviderDocumentType.collaborativeAgreement:
      return (
        <CollaborativeAgreementSignedPreview document={document.document} datetime={document.datetime} />
      );
    case ProviderDocumentType.collaborativeAgreementCounterSignatureRequired:
      return (
        <CollaborativeAgreementCounterSignatureRequiredPreview
          document={document.document}
          onSign={agreementId => setSelectedDocumentId(agreementId)}
        />
      );
    case ProviderDocumentType.collaborativeAgreementCounterSigned:
      return (
        <CollaborativeAgreementCounterSignedPreview document={document.document} />
      );
    case ProviderDocumentType.collaborativeAgreementExpired:
      return (
        <CollaborativeAgreementExpiredPreview
          document={document.document}
          onSign={agreementId => setSelectedDocumentId(agreementId)}
        />
      );
    case ProviderDocumentType.collaborativeAgreementExpiring:
      return (
        <CollaborativeAgreementExpiringPreview
          document={document.document}
          onSign={agreementId => setSelectedDocumentId(agreementId)}
        />
      );
    case ProviderDocumentType.stateExhibit:
      return (
        <StateExhibitSignedPreview document={document.document} />
      );
    case ProviderDocumentType.uploadedProviderDocument:
      return (
        <UploadedProviderDocumentPreview
          document={document.document}
          onDeleteSuccess={() => setSelectedDocumentId(null)}
        />
      );
    default:
      return (
        <DocumentLayout
          title="Unknown document"
          subtitle=" "
        >
          Unknown document type
        </DocumentLayout>
      );
  }
};
